var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMcCannMiltonKeynesLogoWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 435.69 120.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.29,113.71V101.6a25,25,0,0,0-12.52-2.95c-15.57,0-26.16,10.18-26.16,25.34,0,15,10.28,25.34,25,25.34A27.2,27.2,0,0,0,210.29,146V133.56a15,15,0,0,1-12.42,5.9c-9.36,0-15.06-5.9-15.06-15.77,0-9.47,5.8-15.58,14.55-15.58a17.16,17.16,0,0,1,12.93,5.6",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.64,148,140.55,72.34l-16.29,41.32c-1.32,3.36-2.44,6.82-3.46,10.38-.91-3.15-2.14-6.61-3.56-10.18L100.65,72.34,72.46,148h11.8L97.9,110.91a98.61,98.61,0,0,0,3.56-11.3c1.22,4.28,2.55,8.15,3.87,11.61l15.37,39.59,14.66-38.88c.4-1.22,1.83-5.19,4-12.21,1.11,3.87,2.44,7.63,3.86,11.5L156.93,148Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.1,147.4H454V96.81a58.24,58.24,0,0,0,7,8.15l47.12,45.29V74.63H497.25v50.48a93.21,93.21,0,0,0-7.94-8.86L443.1,71.78Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.35,147.4h10.89V96.81a58.83,58.83,0,0,0,7,8.15l47.13,45.29V74.63H417.5v50.48a93.21,93.21,0,0,0-7.94-8.86L363.35,71.78Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.32,92.34l.61-11.91a39.7,39.7,0,0,0-23.51-7.53c-10.89,0-20.36,3.76-27.58,10.89a37.68,37.68,0,0,0-11.1,27.37,38.07,38.07,0,0,0,11,27.39c7.13,7,16.7,10.78,27.89,10.78,8.75,0,16.18-2.24,22.6-6.81V129.18c-7.13,6.11-14.86,9.16-23.51,9.16-14.56,0-25.65-11.09-25.65-27.07,0-16.19,10.89-27.48,26.87-27.48,8.24,0,15.67,2.85,22.39,8.55",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.32,71.78,286.1,147.4h12.42L307,128.67h28.8L344,147.4h12.53Zm-10,47,7.43-16.59A56.35,56.35,0,0,0,321.42,94a68.82,68.82,0,0,0,2.75,8.24l7.43,16.59Z",
    transform: "translate(-72.46 -71.78)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MILTON_KEYNES",
    "data-name": "MILTON KEYNES"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.6,176.6a12.51,12.51,0,0,1-1.1,3.31l-6.27,12.76-6.26-13a18.66,18.66,0,0,1-1.17-3.05,17.14,17.14,0,0,1-.44,3.31l-2.58,11.79H124.2l5.66-24.88,7.07,15c.2.43.63,1.5,1.3,3.24.47-1.34,1-2.41,1.38-3.24l6.9-15,5.79,24.88h-3.62L146,179.88C145.94,179.44,145.84,178.37,145.6,176.6Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.79,167.75h3.88V191.7h-3.88Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.57,167.75h3.88v20.47h8.71v3.48H177.57Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.48,191.7h-3.89V171.07h-6.36v-3.32h16.58v3.32h-6.33Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.65,188.66a13,13,0,0,1-18.12,0,12.49,12.49,0,0,1,0-17.79,13.07,13.07,0,0,1,18.12,0,12.36,12.36,0,0,1,3.75,8.91A12.17,12.17,0,0,1,240.65,188.66Zm-2.88-15.24a8.49,8.49,0,0,0-6.17-2.62,8.6,8.6,0,0,0-6.19,2.62,9.17,9.17,0,0,0,0,12.69,8.62,8.62,0,0,0,12.36,0,9.09,9.09,0,0,0,0-12.69Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.16,166.82l15.2,14.63a31,31,0,0,1,2.62,2.92V167.75h3.58v24.89l-15.51-14.9a19.29,19.29,0,0,1-2.31-2.68V191.7h-3.58Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.77,167.75h3.89v9.92l8.6-9.92H322l-9.48,10.66,10.62,13.29h-5l-9.48-12.22V191.7h-3.89Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.84,167.75H345.2v3.32h-9.48v6h9.48v3.41h-9.48v7.74h9.48v3.48H331.84Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.12,180.75l-8.07-13h4.08l5,8.14c.11.17.47.81,1,1.91a11.76,11.76,0,0,1,1-2l5.16-8h3.89l-8.24,13V191.7h-3.85Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.12,166.82l15.21,14.63a29.51,29.51,0,0,1,2.61,2.92V167.75h3.58v24.89L388,177.74a19.29,19.29,0,0,1-2.31-2.68V191.7h-3.59Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.32,167.75h13.37v3.32h-9.48v6h9.48v3.41h-9.48v7.74h9.48v3.48H415.32Z",
    transform: "translate(-72.46 -71.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.18,185.47c.57,2.15,2.18,3.29,4.63,3.29s3.78-1.41,3.78-3.55c0-2.35-1.78-2.92-4.25-4.12-4.26-2.08-6.6-3.69-6.6-7.31,0-3.85,2.84-6.56,7.2-6.56,3.55,0,6,1.44,6.9,3.95l-3,1.58a4,4,0,0,0-3.55-2.18c-2.11,0-3.42,1.2-3.42,3,0,2.31,1.88,3,4.56,4.26,4.22,1.94,6.2,3.65,6.2,7.1,0,4.45-3,7.4-7.94,7.4-4.09,0-6.77-1.94-7.57-5.43Z",
    transform: "translate(-72.46 -71.78)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMcCannMiltonKeynesLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/McCann_Milton Keynes_Logo_White.656285d3468c9c81d762337ce87d0b51.svg";